import React, { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import getActiveSubscription from "../../services/getActiveSubscription";

const OnSubscription = ({ children }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [hasSubscription, setHasSubscription] = useState(false);

  useEffect(() => {
    const checkSubscription = async () => {
      try {
        const orders = await getActiveSubscription();

        if (orders?.length > 0) {
          setHasSubscription(true);
        } else {
          navigate('/alert', {
            state: {
              type: 'denied',
              message: 'You must have a subscription',
              buttonText: 'Buy one',
              buttonAction: '/pricing',
            },
          });
        }
      } catch (err) {
        console.error("Error fetching subscriptions:", err);
        navigate('/alert', {
          state: {
            type: 'error',
            message: 'Something went wrong. Please try again.',
            buttonText: 'Go back',
            buttonAction: '/',
          },
        });
      } finally {
        setLoading(false);
      }
    };

    checkSubscription();
  }, [navigate]);

  if (loading) {
   // return <></>;
  }

  if (!hasSubscription) {
    return null;
  }

  return children;
};

export default OnSubscription;
